"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.path = exports.requestSchema = void 0;
const zod_1 = require("zod");
exports.requestSchema = zod_1.z.object({
    products: zod_1.z
        .array(zod_1.z.string().regex(/^PRO\d+[A-Z]{2}$/, {
        message: "String must be in the format 'PRO{number}{two-letter country code}'",
    }))
        .nonempty(),
});
exports.path = '/landing-page-product-details';
//# sourceMappingURL=index.js.map